export default "__VITE_ASSET__AmRuFpDg__"